import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Container } from '@amzn/dvui/dist/Container'
import { Link } from '@amzn/dvui/dist/Link'
import { Text } from '@amzn/dvui/dist/Text'
import * as st from './scoutBanner.module.scss'
import * as stUtility from '../utilityClasses.module.scss'

export interface IScoutBannerProps {
  content?: WpsRuntime.atv.wps.ScoutBannerModelProps
}

export const ScoutBannerComp = ({ content }: IScoutBannerProps) =>
  content ? (
    <Container className={`${stUtility.pageSection} ${st.scoutBanner}`}>
      <h2 className={st.scoutBannerDiscover}><Text string={content.discover} /></h2>
      <Link href={content.pageLink}>
        <div className={st.scoutBannerBody} >
          <div className={st.scoutBannerBodyContents} >
            <h2><strong><Text string={content.newBadge} /></strong><Text string={content.header} /></h2>
            <div>
              <Text string={content.body} className={st.scoutBannerBodyText} />
              <Text string={content.tryNow} className={st.scoutTryNow} />
            </div>
          </div>
        </div>
      </Link>
    </Container>) : null

export const ScoutBanner = ScoutBannerComp
